/**
 * Items rendered between prev/next for the dataset-numbers pagination variant.
 * Ellipsis mode applies when {@link ELLIPSIS_THRESHOLD} total pages or more.
 */
export type PaginationNumericItem = number | 'ellipsis-start' | 'ellipsis-end';

/** Show every page index when total pages are below this value (no ellipsis). */
export const ELLIPSIS_THRESHOLD = 7;

/**
 * Builds visible page numbers and ellipsis markers per design-system rules:
 * - Fewer than 7 pages: list `1 … totalPages`.
 * - 7+ pages: `1 2 3 … last` near the start, `1 … last-2 last-1 last` near the end,
 *   otherwise `1 … current … last`.
 */
export function buildPaginationNumericItems(
  totalPages: number,
  currentPage: number,
): PaginationNumericItem[] {
  const total = Math.max(0, Math.trunc(totalPages));
  if (total < ELLIPSIS_THRESHOLD) {
    return Array.from({ length: total }, (_, index) => index + 1);
  }

  const current = Math.min(Math.max(1, Math.trunc(currentPage)), total);

  if (current <= 3) {
    return [1, 2, 3, 'ellipsis-end', total];
  }

  if (current >= total - 2) {
    return [1, 'ellipsis-start', total - 2, total - 1, total];
  }

  return [1, 'ellipsis-start', current, 'ellipsis-end', total];
}
